import { BranchSaveUseCase } from '../../../../application';

export default class BranchSaveService {
    
    async execute(event) {
        const data = await BranchSaveUseCase(event);
        return data;
    }
}
